module.exports = __webpack_public_path__ + "img/image3.6d530bd7.webp";